import { render, staticRenderFns } from "./AdminUsage.vue?vue&type=template&id=65b7f152"
import script from "./AdminUsage.vue?vue&type=script&lang=js"
export * from "./AdminUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports